import styled from 'styled-components';
import { Colors, Helpers, BREAK_POINTS, Metrics } from '@origin-digital/style-guide';

export type ResponsiveLayoutProps = {
  min?: string[];
};

export type BreakPoints = {
  [key: string]: {
    [key: string]: string;
  };
};

const BREAK_POINTS_LOCAL: BreakPoints = BREAK_POINTS;

export const GreyBackground = styled.div`
  background: ${Colors.GREY8};
`;

export const ResponsiveLayout = styled.div<ResponsiveLayoutProps>`
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;

  ${({ min }: ResponsiveLayoutProps) => {
    let mediaQueries = ``;
    if (min) {
      min.forEach((bp: string) => {
        mediaQueries += `@media only screen and (min-width: ${BREAK_POINTS_LOCAL.Min[bp]}) {
            width: ${BREAK_POINTS_LOCAL.Min[bp]}
          }`;
      });
    }
    return mediaQueries;
  }};
`;

export const ResponsiveLayoutThin = styled.div`
  margin: 0 auto 0;
  padding-bottom: ${Metrics.Spacing.P_Y_SM}px;
  position: relative;

  & > div > div {
    width: 100%;
    box-sizing: border-box;
  }

  ${Helpers.media.SM`
     width: 100%;
  `}

  ${Helpers.media.MD`
     width: 508px;
     margin-top: -${Metrics.Spacing.M_Y_LG}px;
     padding-bottom: ${Metrics.Spacing.P_Y_LG}px;
  `}

  ${Helpers.media.LG`
    width: 608px;
    margin-top: -${Metrics.Spacing.M_Y_XL}px;
    padding-bottom: ${Metrics.Spacing.P_Y_XXL}px;
  `}

  ${Helpers.media.XL`
    margin-top: -${Metrics.Spacing.M_Y_XXL}px;
    width: 768px;
  `}
`;

export const ResponsiveGutters = styled.div`
  padding-bottom: ${Metrics.Spacing.P_Y_SM}px;

  ${Helpers.media.MD`
    padding-top: ${Metrics.Spacing.P_Y_LG}px;
    padding-bottom: ${Metrics.Spacing.P_Y_LG}px;
  `} ${Helpers.media.LG`
    padding-top: ${Metrics.Spacing.P_Y_XXL}px;
    padding-bottom: ${Metrics.Spacing.P_Y_XXL}px;
  `};
`;
